import React from 'react';
import styled from 'styled-components';

function Tree({items, children, label, depth = 0}) {
  return (
    <Ul depth={depth}>
      {items.map((item, index) => {
        const itemChildren = children(item, depth);

        return (
          <Li key={index}>
            {label(item, depth)}
            {itemChildren && itemChildren.length > 0 && (
              <Tree
                items={itemChildren} 
                children={children} 
                label={label} 
                depth={depth + 1}
              />
            )}
          </Li>
        )
      })}
    </Ul>
  )
}

const Ul = styled.ul`
  margin: 0;
  padding: 0;
  padding-left: ${props => 32 * props.depth}px;
  list-style: none;
`;

const Li = styled.li`
`;

export default Tree;